module.exports = __webpack_public_path__ + "static/wand_of_paralysis-6f362c2d08902317fd2035c16aee626c.jpeg";